import { dotPath, isNilOrEmpty, isUndefined } from 'ramdasauce'
import { getSrc } from 'gatsby-plugin-image'

import { RichText, Seo } from 'components/atoms'
import { HeroImage, TextSection, NarrowHeroImage } from 'components/molecules'
import {
  Layout,
  PhotoTextGrid,
  LogoGrid,
  ContactForm,
  Video,
  VideoGrid,
  BackgroundVideoHero,
} from 'components/organisms'

export const PageView = (props) => {
  const data = dotPath('props.data.sanityPage', props)
  const navName = dotPath('navigationName', data)
  const seoDesc = dotPath('seoMetaDescription', data)
  const seoImage = dotPath('seoImage', data)
  const seoImageSrc = getSrc(seoImage)
  const layout = data.pageLayout

  const layoutSwitch =
    !isNilOrEmpty(layout) &&
    layout.map((item) => {
      const typename = item.__typename
      switch (typename) {
        case 'SanityBackgroundImageHero': {
          return <HeroImage data={item} key={item.id} />
        }
        case 'SanityPhotoTextGrid': {
          return <PhotoTextGrid data={item} key={item.id} />
        }
        case 'SanityTextSection': {
          return <TextSection data={item} key={item.id} />
        }
        case 'SanityLogoGrid': {
          return <LogoGrid data={item} key={item.id} />
        }
        case 'SanityContactForm': {
          return (
            <ContactForm
              data={item}
              key={item.id}
              footerData={dotPath('props.data.sanityFooter', props)}
            />
          )
        }
        case 'SanityVideo': {
          return <Video {...item} key={item.id} />
        }
        case 'SanityRichTextSection': {
          return <RichText data={item} key={item.id} />
        }
        case 'SanityHomeVideoGrid': {
          return <VideoGrid data={item} key={item.id} />
        }
        case 'SanityVideoLibraryGrid': {
          return <VideoGrid data={item} key={item.id} />
        }
        case 'SanityNarrowBackgroundImageHero': {
          return <NarrowHeroImage data={item} key={item.id} />
        }
        case 'SanityBackgroundVideoHero': {
          return <BackgroundVideoHero data={item} key={item.id} />
        }

        default:
          return ''
      }
    })

  return (
    <Layout footerColor={dotPath('footerColor', data)}>
      <Seo title={navName} pageDesc={seoDesc} pageImage={seoImageSrc} />
      {layoutSwitch}
    </Layout>
  )
}
